import React, { useEffect, useState } from 'react';
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { parseDate } from "./utils";
import { acctMonthToLabel } from "./hooks";
import { CommonButton } from "../common/commonButton";
import { numberFormatter } from "../../utils/generalFunctions";
import format from "date-fns/format";
import LinkIcon from '@mui/icons-material/Link';
import { useSelector } from "react-redux";
import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";

const Container = {
  flexGrow: 1,
  justifyContent: "flex-end",
  alignItems: "flex-end",
  display: "flex",
};

const AllocationDetails = ({
  policy,
  handleClose,
  handleSave,
  isLoading,
  transaction,
  currentRowMode,
  associatedActivities,
  apiProgressBar,
  setApiProgressBar,
  setOpenDialogueId,
  setViaHistoryLink,
  setDialogueAllocation,
  saveDisable
}) => {
  const [activeSection, setActiveSection] = useState('information');
  const { userData } = useSelector((state) => state?.user);

  const handleSectionChange = (event, newSection) => {
    if (newSection !== null) {
      setActiveSection(newSection);
    }
  };

  const openActivityViaHistoryLink = (activity_type) => {
    setOpenDialogueId(activity_type);
    setDialogueAllocation(policy);
    setViaHistoryLink(true);
  }

  const renderInformationSection = () => (
      <Grid container xs={12} spacing={2}>
        <Grid item md={2.4} paddingLeft={2}>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Policy Number
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.policy_id || ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              UMR
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.allocation_umr || ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Master Binder
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.allocation_binder || ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Binding Agreement
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.binding_agreement || ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Producing Entity Name
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.policy_fk?.Producing_Entity || ""}
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={2.4} paddingLeft={4}>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              SCM Partner Name
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.policy_fk?.SCM_Partner === "nan"
                ? ""
                : policy?.policy_fk?.SCM_Partner || ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              EEA/Non EEA
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.allocation_eea?.toUpperCase() ?? (
                (policy?.policy_fk?.Producing_Entity === "MEEA" ||
                  policy?.policy_fk?.Producing_Entity === "MEU2")
                  ? "EEA"
                  : ""
              )}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Accounting Month
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.accounting_monthyear
                ? acctMonthToLabel(policy?.accounting_monthyear)
                : ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Associated Activities
            </Grid>
            {associatedActivities && Object.keys(associatedActivities).length > 0 && (
              <Grid item fontWeight={"bold"}>
                {Object.keys(associatedActivities).join(", ")}
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item md={2.4} paddingLeft={4}>
          <Grid>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Allocated Date
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.allocation_date
                ? customDateFormat(policy?.allocation_date)
                : ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1} marginTop={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              Invoice Verification
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.allocation_invoice_verification || ""}
            </Grid>
          </Grid>
          <Grid marginBottom={1}>
            <Grid item color={"#555"} fontWeight={"medium"}>
              XFI Batch Number
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.XFIbatchno || ""}
            </Grid>
          </Grid>
          <Grid>
            <Grid item color={"#555"} fontWeight={"medium"}>
              GXB Batch Number
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.GXPbatchno || ""}
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={2.4} paddingLeft={4}>
          <Grid width={"200px"}>
            <Grid marginBottom={1}>
              <Grid item color={"#555"} fontWeight={"medium"}>
                Instalment Number
              </Grid>
              <Grid item fontWeight={"bold"}>
                {policy?.policy_installment_number || policy?.installment_number || ""}
              </Grid>
            </Grid>
            <Grid marginBottom={1} marginTop={1}>
              <Grid item color={"#555"} fontWeight={"medium"}>
                Instalment Due Date
              </Grid>
              <Grid item fontWeight={"bold"}>
                {policy?.policy_fk?.Installment_Due_date || policy?.installment_duedate || ""}
              </Grid>
            </Grid>
            <Grid item marginTop={1} color={"#555"} fontWeight={"medium"}>
              Original Amount
            </Grid>
            <Grid item fontWeight={"bold"}>
              {numberFormatter(
                policy?.policy_fk?.Installment_Agency_Amount_in_Orig ?? 0
              )}
            </Grid>
            <Grid item marginTop={1} color={"#555"} fontWeight={"medium"}>
              Settlement Currency
            </Grid>
            <Grid item fontWeight={"bold"}>
              {policy?.settlement_currency ??
                policy?.policy_fk?.Settlement_Ccy ??
                ""}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={2.4}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
          }}
        >
          <Grid width={"240px"}>
            <Grid item color={"#555"} marginTop={1} fontWeight={"medium"}>
              XFI Variance Amount
            </Grid>
            <Grid item fontWeight={"bold"} textAlign={"end"}>
              {numberFormatter(policy?.XFI_Variance_Amount ?? 0)}
            </Grid>
            <Grid item color={"#555"} marginTop={1} fontWeight={"medium"}>
              GXB Amount
            </Grid>
            <Grid item fontWeight={"bold"} textAlign={"end"}>
              {numberFormatter(policy?.GXBAmount ?? 0)}
            </Grid>
            <Grid item color={"#555"} marginTop={1} fontWeight={"medium"}>
              USD Receivable Amount
            </Grid>
            <Grid item fontWeight={"bold"} textAlign={"end"}>
              {numberFormatter(
                policy?.cash_tracker_data?.Receivable_Amount_calculated || 0
              )}
            </Grid>
            <Grid item marginTop={1} color={"#555"} fontWeight={"medium"}>
              USD Allocated Amount
            </Grid>
            <Grid item fontWeight={"bold"} textAlign={"end"}>
              {numberFormatter(
                policy?.cash_tracker_data?.Allocated_Amount_calculated || 0
              )}
            </Grid>
            <Grid item color={"#555"} marginTop={1} fontWeight={"medium"}>
              USD Remaining Balance Amount
            </Grid>
            <Grid item fontWeight={"bold"} textAlign={"end"}>
              {numberFormatter(
                policy?.cash_tracker_data?.Remaining_Balance_usd || 0
              )}
            </Grid>
            <Grid sx={Container} mt={2} mb={3}>
              <CommonButton
                text="Cancel"
                handleClick={() => handleClose("")}
                sx={{ backgroundColor: "#ffff", color: "#000000" }}
                variant="outlined"
              />
              {(userData?.role?.toLowerCase() === "manager" || currentRowMode === "EDIT") && (
                  <CommonButton
                    text="Save"
                    handleClick={handleSave}
                    sx={{ borderRadius: 100, marginLeft: "20px" }}
                    hoverColor="#FF5A01"
                    disabled={apiProgressBar && !saveDisable}
                  />
              )}
            </Grid>
          </Grid>
        </Grid>
          </Grid>
  );

  const renderAuditSection = () => (
        <Grid container spacing={2} mt={2} paddingLeft={2}>
          <Grid item xs={12}>
            <table style={{width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed Field</th>
                  <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Old Value</th>
                  <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>New Value</th>
                  <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed By</th>
                  <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Last Edit Time</th>
                  {/* <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Timestamp</th> */}
                  <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {policy?.cash_allocation_audit_data?.map((audit, index) => (
                  <tr key={index}>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.field_name}</td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.old_value}</td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.new_value}</td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.changed_by}</td>
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.current_edit_datetime}</td>
                    {/* <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.time_diff}</td> */}
                    <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.event_type === 'add' ? 'Added cash allocation' : audit.event_type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Grid>
    </Grid>
  );

  const renderAssociatedActivitiesSection = () => (
    <Grid container spacing={2} mt={2} paddingLeft={2}>
      <Grid item xs={12}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #ddd' }}>Activity Name</th>
              <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #ddd' }}>Reason Type</th>
              <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #ddd' }}>Amount</th>
              <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #ddd' }}>WF Status</th>
              <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #ddd' }}>Created By</th>
              <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #ddd' }}>Created At</th>
              <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #ddd' }}>Workflow Link</th>
            </tr>
          </thead>
          <tbody>
            {associatedActivities && Object.keys(associatedActivities).sort().map((key, index) => {
              if (key == "Correction type") {
                const values = associatedActivities[key];
                const latest = values.reduce((latest, current) => {
                  return new Date(current.created_at) > new Date(latest.created_at) ? current : latest;
                }, values[0]);
                return (
                  <>
                    <tr key={index}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{"Correction Reason"}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.issue_category}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cash_allocation?.receivable_amt}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.workflow_status}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cash_allocation?.created_by?.user_name ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{format(latest.created_at, "dd-MM-yyyy HH:mm:ss")}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }} onClick={() => openActivityViaHistoryLink("correction-types")}><LinkIcon /></td>
                    </tr>
                  </>
                )
              }

              else if (key == "Write off") {
                const values = associatedActivities[key];
                const latest = values.reduce((latest, current) => {
                  return new Date(current.created_at) > new Date(latest.created_at) ? current : latest;
                }, values[0]);
                return (
                  <>
                    <tr key={index}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{"Write-Off"}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.writeoff_reason}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.writeoff_amt}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.workflow_status}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cash_allocation?.created_by?.user_name ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{format(latest.created_at, "dd-MM-yyyy HH:mm:ss")}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }} onClick={() => openActivityViaHistoryLink("write-off")}><LinkIcon /></td>
                    </tr>
                  </>
                )
              }

              else if (key == "Refund") {
                const values = associatedActivities[key];
                const latest = values.reduce((latest, current) => {
                  return new Date(current.created_at) > new Date(latest.created_at) ? current : latest;
                }, values[0]);
                return (
                  <>
                    <tr key={index}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{"Payment"}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.refund_reason}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.refund_amt}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.workflow_status}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cash_allocation?.created_by?.user_name ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{format(latest.created_at, "dd-MM-yyyy HH:mm:ss")}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }} onClick={() => openActivityViaHistoryLink("refund")}><LinkIcon /></td>
                    </tr>
                  </>
                )
              }

              else if (key == "Cross Allocation") {
                const values = associatedActivities[key];
                const latest = values.reduce((latest, current) => {
                  return new Date(current.created_at) > new Date(latest.created_at) ? current : latest;
                }, values[0]);
                return (
                  <>
                    <tr key={index}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{"Cross-Allocation"}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.ca_change}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.ca_amt}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.workflow_status}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cash_allocation?.created_by?.user_name ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{format(latest.created_at, "dd-MM-yyyy HH:mm:ss")}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }} onClick={() => openActivityViaHistoryLink("cross-allocation")}><LinkIcon /></td>
                    </tr>
                  </>
                )
              }

              else if (key == "CFI") {
                const values = associatedActivities[key];
                const latest = values.reduce((latest, current) => {
                  return new Date(current.created_at) > new Date(latest.created_at) ? current : latest;
                }, values[0]);
                return (
                  <>
                    <tr key={index}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{"CFI"}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cfi_change}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cfi_amt}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.workflow_status}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cash_allocation?.created_by?.user_name ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{format(latest.created_at, "dd-MM-yyyy HH:mm:ss")}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }} onClick={() => openActivityViaHistoryLink("cfi")}><LinkIcon /></td>
                    </tr>
                  </>
                )
              }

              else if (key == "Corrective Transfer") {
                const values = associatedActivities[key];
                const latest = values.reduce((latest, current) => {
                  return new Date(current.created_at) > new Date(latest.created_at) ? current : latest;
                }, values[0]);
                return (
                  <>
                    <tr key={index}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{"Corrective Transfer"}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.transfer_pt_bank_account_name}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.transfer_amt}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.workflow_status}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{latest.cash_allocation?.created_by?.user_name ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{format(latest.created_at, "dd-MM-yyyy HH:mm:ss")}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }} onClick={() => openActivityViaHistoryLink("corrective-transfer")}><LinkIcon /></td>
                    </tr>
                  </>
                )
              }
            }
            )}
          </tbody>
        </table>
      </Grid>
    </Grid>
  );


  const renderActivitiesSection = () => (
    <Grid container spacing={2} mt={2} paddingLeft={2}>
      <Grid item xs={12}>
        <table style={{width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#f5f5f5' }}>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Activity Name</th>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Old Policy No</th>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Reason</th>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Amount</th>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Cancelled Date</th>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>WF status</th>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Edited By</th>
              <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Edited At</th>
            </tr>
          </thead>
          <tbody>
            {policy?.deleted_ca &&
              Object.entries(policy.deleted_ca.activities).map(([activityName, arr]) =>
                arr.map((item, idx) => {
                  const workflowItem = policy.deleted_ca.workflow_data?.find(wf => wf.id === item.id);
                  return (
                    <tr key={`${activityName}-${idx}`}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{activityName}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{policy.deleted_ca.policy_number}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{workflowItem?.writeoff_reason ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{numberFormatter(workflowItem?.writeoff_amt ?? 0)}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{customDateFormat(policy?.deleted_time)}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{workflowItem?.workflow?.workflow_status ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{policy.created_by?.user_name ?? ""}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{format(policy.deleted_time, "dd-MM-yyyy HH:mm:ss")}</td>
                    </tr>
                  );
                })
              )
            }
          </tbody>
        </table>
      </Grid>
    </Grid>
  );

  return (
    <div style={{display: 'block', paddingTop: "20px"}}>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12}>
          <ToggleButtonGroup
            value={activeSection}
            exclusive
            onChange={handleSectionChange}
            aria-label="section toggle"
            sx={{ 
              mb: 2,
              '& .MuiToggleButton-root': {
                border: '1px solid #000000',
                borderRadius: 0,
                color: '#000000',
                backgroundColor: '#ffffff',
                height: '120px',
                padding: '20px 20px',
                fontSize: '18px',
                '&.Mui-selected': {
                  backgroundColor: 'rgb(255, 90, 1)',
                  color: '#ffffff',
                  '&:hover': {
                    backgroundColor: 'rgb(255, 90, 1)',
                  }
                },
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
                '&:first-of-type': {
                  borderTopLeftRadius: '20px',
                  borderBottomLeftRadius: '20px',
                  borderRight: '2px solid #000',
                },
                '&:last-of-type': {
                  borderTopRightRadius: '20px',
                  borderBottomRightRadius: '20px',
                },
              }
            }}
          >
            <ToggleButton value="information" aria-label="information section">
              Information
            </ToggleButton>
            <ToggleButton value="audit" aria-label="audit trail section">
              Audit Trail
            </ToggleButton>
            <ToggleButton value="associated_activities" aria-label="associated activities section">
              Associated Activities
            </ToggleButton>
            <ToggleButton value="activities" aria-label="activities section">
              Deleted Activities
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>

      {activeSection === 'information' && renderInformationSection()}
      {activeSection === 'audit' && renderAuditSection()}
      {activeSection === 'associated_activities' && renderAssociatedActivitiesSection()}
      {activeSection === 'activities' && renderActivitiesSection()}
    </div>
  );
};

export default AllocationDetails;
